var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_10881)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 25C19.4036 25 25.0001 19.4035 25.0001 12.5C25.0001 5.59644 19.4036 0 12.5001 0C5.59645 0 0 5.59644 0 12.5C0 19.4035 5.59645 25 12.5001 25ZM9.40884 18.5701C9.75839 18.744 10.0741 18.5701 10.0741 18.1491C10.0661 8.80291 10.1052 8.66109 10.0588 8.62276C10.0561 8.62055 10.0532 8.61869 10.0498 8.6154L5.90319 6.54328C5.43605 6.31062 5.22944 6.46633 5.22944 6.81048V16.0362C5.22944 16.1605 5.26943 16.2866 5.34759 16.4131C5.42575 16.5398 5.52148 16.6301 5.63539 16.684L9.40884 18.5701ZM14.9266 16.4817L10.5934 9.4727V14.329L14.9266 16.4817ZM19.7707 18.1491V9.61874L15.3889 16.7161L18.9672 18.4968C19.0915 18.5671 19.2187 18.6022 19.3484 18.6022C19.4781 18.6022 19.5811 18.5604 19.6568 18.4768C19.7331 18.3932 19.7707 18.2842 19.7707 18.1491ZM17.6653 12.0423C19.0528 9.79572 19.7464 8.66388 19.7464 8.64752C19.7464 8.62571 19.7356 8.60935 19.7143 8.59905L15.3241 6.41362C15.1271 6.31547 14.8339 6.35667 14.691 6.59176L12.062 10.8566L15.2265 15.9878C15.4646 15.6049 16.2778 14.289 17.6653 12.0423Z",
    fill: "#4AFEBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_10881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.116e653436656b9ec5ce2b570de5246f.svg";
export { ForwardRef as ReactComponent };